// src/components/Hizmetler.js
import React from 'react';
import './Hizmetler.css';

const hizmetler = [
  {
    ikon: '🔧',
    baslik: 'Servis & Bakım Hizmetleri',
    aciklama:
      'Tüm marka kompresörler için arıza müdahalesi, periyodik bakım, yağ–filtre değişimleri ve revizyon çözümleri sunuyoruz. Sistemlerinizin güvenli, verimli ve uzun ömürlü çalışması için 7/24 servis desteği sağlıyoruz.'
  },
  {
    ikon: '🔄',
    baslik: 'Genel Revizyon ve Yenileme',
    aciklama:
      'Lupamat, Atlas Copco, Kaeser, Ingersoll Rand, Dalgakıran, Sarmak, Ekomak ve diğer kompresör markalarına ait kompresörleriniz için kapsamlı revizyon hizmetleri sunuyoruz. Orijinal parça garantisi ve uzman mühendislik desteğiyle sistemlerinizi yeniliyoruz.'
  },
  {
    ikon: '📈',
    baslik: 'Enerji Verimliliği Analizi',
    aciklama:
      'İşletmenizin enerji tüketimini analiz ederek sürdürülebilirlik, maliyet avantajı ve karbon ayak izi azaltımı hedefli çözümler geliştiriyoruz. Kompresör sistemlerinde enerji optimizasyonuyla ciddi tasarruf sağlayabilirsiniz.'
  },
  {
    ikon: '📏',
    baslik: 'Debi & Hava Kalitesi Ölçümleri',
    aciklama:
      'Üretilen havanın debisi, kalitesi, nem oranı ve sistem kayıpları özel cihazlarla ölçülür. Dew point, hava kaçak ve basınç düşümü analizleri ile sistem sağlığınız detaylı raporlanır.'
  },
  {
    ikon: '⚙️',
    baslik: 'Orijinal Yedek Parça Tedariki',
    aciklama:
      'Tüm önde gelen markalara ait kompresörler için orijinal yedek parçalar sunuyoruz. Filtre, yağ, seperatör, valf, keçe ve diğer tüm bileşenler stoktan hızlı temin edilir.'
  },
  {
    ikon: '🚛',
    baslik: 'Kompresör Satış ve Kiralama',
    aciklama:
      'İhtiyacınıza uygun vidalı, pistonlu ya da turbo kompresörleri hem satış hem de kısa/uzun vadeli kiralama seçenekleriyle sunuyoruz. Projenize özel çözümler için danışabilirsiniz.'
  },
  {
    ikon: '📊',
    baslik: 'Hava Kaçak ve Enerji Kayıp Analizi',
    aciklama:
      'Hava kaçakları tespit edilerek işletmenizin enerji israfı engellenir. Akustik algılayıcılarla kaçak noktaları belirlenir ve size detaylı iyileştirme raporu sunulur.'
  },
  {
    ikon: '📞',
    baslik: '7/24 Teknik Destek',
    aciklama:
      'Beklenmedik arızalar ya da planlı bakımlar için haftanın her günü ulaşabileceğiniz uzman teknik servis ekibimiz hizmetinizdedir.'
  }
];

const Hizmetler = () => {
  return (
    <div className="hizmetler-container">
      <h1 className="hizmetler-title">🛠️ Hizmetlerimiz</h1>
      <p className="hizmetler-description">
        Endüstriyel hava sistemlerinizin tüm ihtiyaçlarına yönelik mühendislik çözümleri ve profesyonel servis hizmetleri sunuyoruz.
      </p>
      <div className="hizmetler-grid">
        {hizmetler.map((h, i) => (
          <div key={i} className="hizmet-kart">
            <div className="hizmet-ikon">{h.ikon}</div>
            <h3 className="hizmet-baslik">{h.baslik}</h3>
            <p className="hizmet-aciklama">{h.aciklama}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hizmetler;
